import { mixins } from 'vue-class-component';
import { Component, Prop } from 'vue-property-decorator';
import FieldWrapper from '../field-wrapper/field-wrapper.vue';
import AbstractField from '../abstract-field/abstract-field';

@Component({
  name: 'bpc-checkbox',
  components: {
    'bpc-field-wrapper': FieldWrapper,
  },
})
export default class Checkbox extends mixins(AbstractField) {
  @Prop({ type: [Boolean, String, Number] }) readonly value: boolean | string | 1 | 0;

  get model(): boolean {
    // we ensure with this to return always a boolean true or false
    if (this.value === 'false' || this.value === '0') {
      return false;
    }
    return !!this.value;
  }

  set model(value: boolean) {
    this.$emit('input', value);
    if (this.eventsConfig && this.eventsConfig.emit) {
      this.eventsConfig.emit.forEach(event => {
        this.$root.$emit(event, value);
      });
    }
  }

  mounted(): void {
    // this.model = this.value;
    console.log('checkboxWrapperAttributes', this.wrapperAttributes);
  }

  // @Watch('model')
  // onModelChanged(val: string) {
  //   this.$emit('input', val);
  // }
}
